/* global Office */

export default function makePromise(fn, context) {
  return (...args) =>
    new Promise((resolve, reject) => {
      const callback = result => {
        if (result.status === 'success' || result.status === Office.AsyncResultStatus.Succeeded) {
          resolve(result.value)
        } else {
          reject(result.error)
        }
      }
      args.push(callback)
      fn.apply(context, args)
    })
}
